import { useContext } from 'react';
import { getNameExtension } from '../../../../../TemporaryConmonents/Files/helpers/getNameExtension';
import { isNotValidateSize } from '../../../../../TemporaryConmonents/Files/helpers/isNotValidateSize';
import { MeasuremntsContext } from '../../../Context/MeasuremntsContext';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

const validatedFormat = ['png', 'jpg', 'jpeg', 'svg', 'gif'];

export const useUploadImage = () => {
    const { t } = useTranslation();

    const { setImageList, imageList, showPopup, hidePopup } = useContext(MeasuremntsContext);
    const onImageChange = (images) => {
        let uploadImageList = [];
        let overallSize = 0;
        if (images.length > 10) {
            showPopup({
                needCrossIcon: false,
                text: t('useUploadImage.errors.files_count'),
                cancel: t('button.got_it.text'),
                onSubmit: async () => {},
                onCancel: () => hidePopup(),
            });
            return;
        }

        for (let i = 0; i < images.length; i++) {
            const { extension } = getNameExtension(images[i].file.name);
            if (!validatedFormat.includes(extension.toLowerCase())) {
                showPopup({
                    needCrossIcon: false,
                    text: t('Files.Popup.return.textError.format'),
                    cancel: t('button.got_it.text'),
                    onSubmit: async () => {},
                    onCancel: () => hidePopup(),
                });
                return;
            }

            const checkValidate = isNotValidateSize(images[i].file.size, 100);

            if (checkValidate) {
                showPopup({
                    needCrossIcon: false,
                    text: t('useUploadImage.errors.size'),
                    cancel: t('button.got_it.text'),
                    onSubmit: async () => {},
                    onCancel: () => hidePopup(),
                });
                return;
            }
            uploadImageList.push({
                file: images[i].file,
                previewUrl: images[i].previewUrl,
            });

            overallSize += images[i].file.size;
        }

        const isOverallSize = isNotValidateSize(overallSize);

        if (isOverallSize) {
            showPopup({
                needCrossIcon: false,
                text: t('useUploadImage.errors.size'),
                cancel: t('button.got_it.text'),
                onSubmit: async () => {},
                onCancel: () => hidePopup(),
            });
            return;
        }
        setImageList((prev) => [...uploadImageList, ...prev]);
    };

    return { onImageChange };
};
